import { render, staticRenderFns } from "./InvoiceChangeRequestList.vue?vue&type=template&id=74635d80"
import script from "./InvoiceChangeRequestList.vue?vue&type=script&lang=js"
export * from "./InvoiceChangeRequestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports